import React from 'react'


function RightSection({imageURL, productName, productDescription, tryDemo, learnMore}) {
    return (
        <div className='continer my-4'>
            <div className='row' style={{ paddingInline: "100px", alignItems: 'center'}}>

                <div className='col-6' style={{ padding: "100px" }}>
                    <h1>{productName}</h1>
                    <p>{productDescription}</p>
                    <div style={{ display: 'flex', flexDirection: 'column', gap: '2rem' }}>
                        <div style={{ display: 'flex', gap: '2rem' }}>
                            <a style={{ textDecoration: 'none' }} href={tryDemo}>Try Demo →</a>
                        </div>
                    </div>
                </div>

                <div className='col-6' style={{ paddingRight: "100px" }}>
                    <img src={imageURL} alt='img' />
                </div>

            </div>
        </div>
    );
}

export default RightSection;